/**
 * Element factory
 */
export class ElementFactory {
}
//# sourceMappingURL=ElementFactory.js.map